import { queryOptions } from "@tanstack/solid-query";
import { axiosClient } from "~/js/network/axiosClient";
import type { IModifierRecord } from "../helpers/types/INodeDefinition";
import { fetchAirTablePagination } from "./fetchAirTablePagination";

type AirtableStyle = {
	value: string;
	name: string;
	coverCdn: string;
	description: string;
	inputs: string;
	params: string;
	globalId: string;
};
export type IStyleItem = {
	value: string;
	name: string;
	cover: string;
	description: string;
	inputs: IModifierRecord;
	params: IModifierRecord;
	globalId: string;
};
export class StylesApi {
	static key_StyleList = "key_StyleList";

	static async getStylesList(globalId: string) {
		const { records } = await fetchAirTablePagination<AirtableStyle>({
			baseId: "appqIlvnjfPjskCLX",
			tableName: "styles",
			view: "Main",
			axiosInstance: axiosClient.axiosClient,
			formula: `globalId="${globalId}"`
		});

		const items: IStyleItem[] = [];
		for (const record of records) {
			const item = {} as IStyleItem;
			item.value = record.fields.value;
			item.name = record.fields.name;
			item.globalId = record.fields.globalId;
			item.description = record.fields.description;
			item.cover = record.fields.coverCdn;

			try {
				item.inputs = JSON.parse(record.fields.inputs);
				item.params = JSON.parse(record.fields.params);
			} catch (e) {
				console.error(e);
			}
			items.push(item);
		}
		return items;
	}

	static getStyleByIdQueryOptions(styleId: string, globalId: string) {
		return queryOptions({
			queryKey: [StylesApi.key_StyleList, globalId, styleId],
			queryFn: () => StylesApi.getStyleById(styleId, globalId)
		});
	}

	static async getStyleById(styleId: string, globalId: string): Promise<IStyleItem | null> {
		const { records } = await fetchAirTablePagination<AirtableStyle>({
			baseId: "appqIlvnjfPjskCLX",
			tableName: "styles",
			view: "Main",
			axiosInstance: axiosClient.axiosClient,
			formula: `AND(value="${styleId}", globalId="${globalId}")`
		});

		if (records.length === 0) {
			return null;
		}

		const record = records[0];
		const item = {} as IStyleItem;
		item.value = record.fields.value;
		item.name = record.fields.name;
		item.globalId = record.fields.globalId;
		item.description = record.fields.description;
		item.cover = record.fields.coverCdn;

		try {
			item.inputs = JSON.parse(record.fields.inputs);
			item.params = JSON.parse(record.fields.params);
		} catch (e) {
			console.error(e);
			return null;
		}

		return item;
	}
}
